import React, { useState, useEffect } from 'react';

const MailOpenLandingPage = () => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [clickedOn, setUserTime] = useState(null);
  const [userTimezone, setUserTimezone] = useState(null);
  const [userIp, setUserIp] = useState(null);
  const [location, setLocation] = useState(null);

  // Parse query parameters from the URL
  const queryParams = new URLSearchParams(window.location.search);
  const mailLogId = queryParams.get('MId');
  //const token = queryParams.get('t');

  // Get API URL from environment variables
  const apiUrl = process.env.REACT_APP_API_URL;

  // Function to fetch the user's IP address
  const fetchUserIp = async () => {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      setUserIp(data.ip);
      return data.ip;
    } catch (error) {
      console.error('Error fetching IP:', error);
      return null;
    }
  };

  // Function to fetch geolocation based on IP
  const fetchGeolocation = async (ip) => {
    try {
      const response = await fetch(`https://ipinfo.io/${ip}/json`);
      const data = await response.json();

      // Get current date and time details
      const currentDate = new Date();
      const userLocalTime = currentDate.toLocaleString();
      
      // Improved timezone handling
      const timezoneOffset = currentDate.getTimezoneOffset();
      const timezoneString = currentDate.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ')[2];
      
      setUserTime(userLocalTime);
      setUserTimezone(timezoneString);
      setLocation(data);

      return { 
        userLocalTime, 
        timezoneOffset, 
        timezoneString, 
        locationData: data 
      };
    } catch (error) {
      console.error('Error fetching location:', error);
      return null;
    }
  };

  // Function to send tracking data to backend
  const sendTrackingData = async (ip, location, localTime, timezone) => {
    try {
      const response = await fetch(`${apiUrl}/mailer/EmailOpenCount`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          MailLogId: mailLogId,
          UserIP: ip,
          UserTimezone: timezone,
          ClickedOn: localTime,
          UserLocation: location
          //Token: token
        }),
      });

      const result = await response.json();
      console.log('Tracking data sent:', result);
      return result;
    } catch (error) {
      console.error('Error sending tracking data:', error);
      return null;
    }
  };

  // Main tracking effect
  useEffect(() => {
    const trackEmailOpen = async () => {
      try {
        // Fetch IP
        const ip = await fetchUserIp();
        
        if (ip) {
          // Fetch geolocation
          const geoData = await fetchGeolocation(ip);
          
          if (geoData) {
            // Send tracking data
            await sendTrackingData(
              ip, 
              geoData.locationData, 
              geoData.userLocalTime, 
              geoData.timezoneString
            );
          }
        }
      } catch (error) {
        console.error('Tracking process error:', error);
      } finally {
        setLoading(false);
        
        // Optional: Redirect or close window
        // window.close(); // Uncomment if you want to auto-close
      }
    };

    trackEmailOpen();
  }, []);

  // Render loading state
  if (loading) {
    return (
      <div style={{
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh'
      }}>
        Tracking email open...
      </div>
    );
  }

  return null;
};

export default MailOpenLandingPage;